import DatabaseSqlite from "better-sqlite3";
import Resource from "../Entity/Resource";
import Database from "./Database";

export default class ResourceRepository {
    private database: DatabaseSqlite.Database;

    public constructor(
        database: Database
    ) {
        this.database = database.getDatabase();
    }

    public getById(id: number): Resource | null {
        try {
            const select = this.database.prepare("SELECT * FROM resources WHERE id = ?;");
            const row: any = select.get(id);
            if (row) {
                return new Resource(row.id, row.name, row.description, row.uuid, row.entity_changed, row.last_verified, row.time_lapse);
            }
        } catch (error) {
            console.error("Error when attempting to retrieve resource by ID:", error);
        }

        return null;
    }

    public save(resource: Resource): void {
        this.getById(resource.getId()) ? this.update(resource) : this.insert(resource);
    }

    private insert(resource: Resource): void {
        try {
            const insert = this.database.prepare("INSERT OR IGNORE INTO resources (id, name, description, uuid, entity_changed, last_verified, time_lapse) VALUES (?,?,?,?,?,?,?)");
            insert.run(resource.getId(), resource.getName(), resource.getDescription(), resource.getUuid(), resource.getEntityChanged(), resource.getLastVerified(), resource.getTimeLapse());
        } catch (error) {
            console.error("Error when attempting to insert the resource:", error);
        }
    }

    private update(resource: Resource): void {
        try {
            const update = this.database.prepare("UPDATE resources SET name = ?, description = ?, uuid = ?, entity_changed = ?, last_verified = ?, time_lapse = ? WHERE id = ?");
            update.run(resource.getName(), resource.getDescription(), resource.getUuid(), resource.getEntityChanged(), resource.getLastVerified(), resource.getTimeLapse(), resource.getId());
        } catch (error) {
            console.error("Error when attempting to update the resource:", error);
        }
    }

    public remove(id: number) {
        try {
            const remove = this.database.prepare("DELETE FROM resources WHERE id = ?");
            remove.run(id);
        } catch (error) {
            console.error("Error when attempting to delete the resource:", error);
        }
    }
}